import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import classnames from 'classnames'
import "whatwg-fetch"

import * as SaveStatus from '../../constants/SaveStatus'
import TInputForm from "../common/TInputForm";
import { changeSaveStatus, addLink } from '../../actions/mylink'
import { jsonResponseHandler } from "../../utils/FetchHelper"
import { validate } from './MyLinkFormValidator'
import { isUrl } from '../../utils/formatter'
import {addPrefix} from "../../utils/UriUtil";

const initialState = {
	open: false,
	url: '',
	name: '',
	validated: false
}

@connect(state => ({
	links: state.link.my.links,
	saveStatus: state.link.my.saveStatus
}), dispatch => ({
	handleChangeSaveStatus(saveStatus) {
		dispatch(changeSaveStatus(saveStatus))
	},
	handleAdd(link) {
		dispatch(addLink(link))
	},
    dispatch
}))
class MyLinkAddForm extends Component {

	constructor() {
		super()
		this.state = initialState
	}

	@autobind
	handleOpen() {
		this.setState({
			open: true
		})
	}

	@autobind
	handleSubmit(e) {
		e.preventDefault();
		const { url, name, validated } = this.state;
		const { links, handleAdd, handleChangeSaveStatus, dispatch, saveStatus } = this.props;

		if (!validated) {
			return false
		}

		handleChangeSaveStatus(SaveStatus.DOING);

		fetch(addPrefix("/manage/link/my.json"), {
			method: 'post',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				ordering: links.map(item => item.linkId),
				link: {
					name: name,
					url: url
				}
			})
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				handleAdd(data)
				this.setState(initialState)
			})
			.catch(e => {
				console.error(e)
				handleChangeSaveStatus(saveStatus)
			})
	}

	@autobind
	handleReset() {
		this.setState({
			open: false
		})
	}

	@autobind
	handleChangeUrl(value) {
		const { name } = this.state

		this.setState({
			url: value,
			validated: validate(name, value)
		})
	}

	@autobind
	handleChangeName(value) {
		const { url } = this.state

		this.setState({
			name: value,
			validated: validate(value, url)
		})
	}

	render() {
		const { open, validated } = this.state

		if (this.props.links.length >= 100) {
			return (
				<div className="wrap_add">
					<p className="item_noti">
						<span className="wrap_ico"><span className="ico_blog"/></span>더 이상 링크를 추가할 수 없습니다.
					</p>
				</div>
			)
		}

		return (
			<div className={classnames("wrap_add", { "item_edit": open })}>
				{ !open &&
					<label className="lab_btn lab_add">
						<span className="ico_blog ico_add" />
						링크 추가
						<input type="button" className="btn_g" value="링크 추가" onClick={this.handleOpen} />
					</label>
				}

				{ open &&
					<form className="item_order" onSubmit={this.handleSubmit} onReset={this.handleReset}>
						<div className="edit_item type_double" style={{display:'block'}}>
							<label className="lab_tf">
								<strong className="screen_out">주소</strong>
								<TInputForm type="text" className="tf_blog" placeholder="url을 입력해주세요" value={this.state.url} focus={true} onChange={this.handleChangeUrl} />
							</label>
							<label className="lab_tf">
								<strong className="screen_out">링크명</strong>
								<TInputForm type="text" className="tf_blog" placeholder="이름" value={this.state.name} onChange={this.handleChangeName} />
							</label>
							<div className="order_btn">
								<button type="reset" className="btn_cancel">취소</button>
								<button type="submit" className={classnames("btn_default", { "btn_off": !validated })} disabled={!validated}>추가</button>
							</div>
						</div>
					</form>
				}
			</div>
		)
	}
}

export default MyLinkAddForm
